<template>
	<tr @click="view" class="row">
		<td class="text">
			<span>{{ title }}</span>
		</td>
		<td class="text">
			<span>{{ name | dashEmpty }}</span>
		</td>
		<td class="text">
			<span>{{ email | dashEmpty }}</span>
		</td>
		<td class="text">
			<span>{{ created }}</span>
		</td>
		<td class="actions">
			<!-- Approve/decline -->
			<Action
				v-if="canApprove"
				title="Approve"
				class="action action--approve"
				:disabled="updating"
				@click.stop="approveSelf"
				><IconApprove title="Approve"
			/></Action>
			<Action
				v-if="canDecline"
				title="Decline"
				class="action action--decline"
				:disabled="updating"
				@click.stop="declineSelf"
				><IconDecline title="Decline"
			/></Action>
			<!-- Promote/demote -->
			<Action
				v-if="canPromote"
				title="Add to shortlist"
				class="action action--promote"
				:disabled="updating"
				@click.stop="promoteSelf"
				><IconPromote title="Add to shortlist"
			/></Action>
			<Action
				v-if="canDemote"
				title="Remove from shortlist"
				class="action action--demote"
				:disabled="updating"
				@click.stop="demoteSelf"
				><IconDemote title="Remove from shortlist"
			/></Action>
			<!-- Show/hide in gallery -->
			<Action
				v-if="canShow"
				title="Show in gallery"
				class="action action--promote"
				:disabled="updating"
				@click.stop="showSelf"
				><IconShow title="Show in gallery"
			/></Action>
			<Action
				v-if="canHide"
				title="Hide from gallery"
				class="action action--demote"
				:disabled="updating"
				@click.stop="hideSelf"
				><IconHide title="Hide from gallery"
			/></Action>
		</td>
	</tr>
</template>

<script>
import IconApprove from 'mdi-vue/Check'
import IconDecline from 'mdi-vue/Close'
import IconPromote from 'mdi-vue/PlaylistPlus'
import IconDemote from 'mdi-vue/PlaylistRemove'
import IconShow from 'mdi-vue/Eye'
import IconHide from 'mdi-vue/EyeOff'
import Action from '@/components/shared/Action'

import { enums } from 'protoswipe-shared'
const { SubmissionStatus } = enums

export default {
	name: 'submissions-table-row',
	props: {
		id: Number,
		title: String,
		name: String,
		email: String,
		status: String,
		round: Number,
		promote: Boolean,
		hideFromGallery: Boolean,
		created_at: String,
		updating: Boolean,
		campaignRound: Number,
		isShortlist: Boolean
	},
	computed: {
		created() {
			return new Date(this.created_at).toLocaleDateString()
		},
		isInActiveCampaign() {
			return this.$route.name === 'Current Campaign'
		},
		isInCurrentRound() {
			return this.round === this.campaignRound
		},
		isNew() {
			return this.status === SubmissionStatus.new
		},
		isApproved() {
			return this.status === SubmissionStatus.approved
		},
		canApprove() {
			return (
				!this.isShortlist &&
				(this.isInCurrentRound || this.status === SubmissionStatus.new) &&
				this.status !== SubmissionStatus.approved
			)
		},
		canDecline() {
			return (
				!this.isShortlist &&
				(this.isInCurrentRound || this.status === SubmissionStatus.new) &&
				this.status !== SubmissionStatus.declined
			)
		},
		canPromote() {
			return (
				this.isInCurrentRound &&
				this.isInActiveCampaign &&
				this.status === SubmissionStatus.approved &&
				!this.promote
			)
		},
		canDemote() {
			return this.isInCurrentRound && this.isInActiveCampaign && this.promote
		},
		canShow() {
			return !this.isNew && !this.isShortlist && this.hideFromGallery
		},
		canHide() {
			return !this.isNew && !this.isShortlist && !this.hideFromGallery
		}
	},
	methods: {
		update(payload) {
			this.$emit('update', { id: this.id, ...payload })
		},
		approveSelf() {
			const data = { status: SubmissionStatus.approved }
			if (this.status === SubmissionStatus.new) data.round = this.campaignRound
			this.update(data)
		},
		declineSelf() {
			const data = { status: SubmissionStatus.declined }
			if (this.promote) data.promote = false
			if (this.status === SubmissionStatus.new) data.round = this.campaignRound
			this.update(data)
		},
		promoteSelf() {
			this.update({ promote: true })
		},
		demoteSelf() {
			this.update({ promote: false })
		},
		showSelf() {
			this.update({ hideFromGallery: false })
		},
		hideSelf() {
			this.update({ hideFromGallery: true })
		},
		view() {
			this.$emit('view', { id: this.id })
		}
	},
	components: {
		IconApprove,
		IconDecline,
		IconPromote,
		IconDemote,
		IconShow,
		IconHide,
		Action
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.row {
	cursor: pointer;
	&:hover td span {
		text-decoration: underline;
	}
}

.action {
	display: inline-block;
	&--approve {
		color: $green-50;
	}
	&--decline {
		color: $red-85;
	}
	&--promote {
		color: $blue-73;
	}
	&--demote {
		color: $orange-95;
	}
}
</style>
